<template>
  <div class="wrap">
    <h1 class="common-header">
      <i class="el-icon-arrow-left icon-button" @click="$emit('close', 1)"></i>
      {{ title }}
    </h1>
    <div class="by-content">
      <div class="form-wrap" ref="formWrap">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <!-- 姓名 -->
          <el-form-item :label="$t('142')">
            <el-input
              class="search_name"
              v-model="form.search_name"
              :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
            ></el-input>
          </el-form-item>
          <!-- 日期 -->
          <el-form-item :label="$t('307')">
            <el-date-picker
              disabled
              v-model="form.date"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('407')"
              :end-placeholder="$t('408')"
              format="yyyy-MM-dd"
              valueFormat="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <!-- 部门 -->
          <el-form-item :label="$t('27')" prop="region">
            <department :change="handlerChangeDep" :mprop="{ checkStrictly: true }" :placeholder="$t('221')" />
          </el-form-item>
          <el-form-item :label="$t('24')" prop="region">
            <job v-model="form.job_title_id" />
          </el-form-item>
          <!-- 在职状态 -->
          <el-form-item :label="$t('state')" prop="region">
            <JobStatus v-model="form.states" multiple clearable collapse-tags />
          </el-form-item>
          <!-- 直线上级 -->
          <el-form-item :label="$t('980')" prop="region">
            <LinearSuperior v-model="form.manager_id" clearable />
          </el-form-item>
          <!-- 查询 -->
          <el-form-item>
            <el-button type="primary" @click="handlerSearch">{{ $t('69') }}</el-button>
          </el-form-item>
          <!-- 导出 -->
          <el-form-item>
            <el-button
              icon="el-icon-download"
              @click="handlerAttendanceExcel"
              v-if="$p('menu.monthly-statistics.export')"
              >{{ $t('68') }}</el-button
            >
          </el-form-item>
          <!-- 更新报表 -->
          <div class="margin-bottom update-select">
            <el-button @click="handleUpdateColums">{{ $t('1933') }}</el-button>
            <p v-if="isShowUpdateTips" style="margin-left: 15px; color: #8c8c8c">{{ $t('update_tips') }}</p>
          </div>
          <!-- 动态展示列 -->

          <!-- 基本信息 -->
          <div class="dynamic-column margin-bottom">
            <div class="dynamic-column-title">{{ $t('312') }}</div>
            <div class="dynamic-column-active margin-left">
              <el-checkbox-group
                v-model="ckeckedColumns"
                @change="columns => handleCheckedCitiesChange(columns, 'basic')"
                key="checkall-basic-group"
              >
                <el-checkbox
                  v-for="item in dynamicColumns.basic"
                  class="margin-bottom"
                  :label="item"
                  :key="item.field_key"
                  >{{ item.field_name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <!-- 全选 -->
            <el-checkbox
              class="select-all-attendance"
              :indeterminate="isIndeterminate"
              key="checkall-basic"
              v-model="checkAll"
              @change="isCheckAll => handleCheckAllChange(isCheckAll, 'basic')"
              >{{ $t('21') }}</el-checkbox
            >
          </div>

          <!-- 考勤统计 -->
          <div class="dynamic-column">
            <div class="dynamic-column-title">{{ $t('583') }}</div>
            <div class="dynamic-column-active margin-left margin-bottom">
              <el-checkbox-group
                v-model="ckeckedColumnsAttdance"
                @change="columns => handleCheckedCitiesChange(columns, 'attendance')"
                key="checkall-attendance-group"
              >
                <el-checkbox
                  v-for="item in dynamicColumns.attendance"
                  :label="item"
                  :key="item.field_key"
                  class="margin-bottom"
                  >{{ item.field_name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <!-- 全选 -->
            <el-checkbox
              class="select-all-attendance"
              :indeterminate="isIndeterminateAttdance"
              v-model="checkAllAttdance"
              key="checkall-attendance"
              @change="isCheckAll => handleCheckAllChange(isCheckAll, 'attendance')"
              >{{ $t('21') }}</el-checkbox
            >
          </div>
        </el-form>
        <!-- 加班动态展示 -->
        <!-- <el-checkbox v-model="overTime" key="overtime"> {{ $t('82') }} </el-checkbox> -->
        <!-- 色块区分 -->
        <ul class="warn-wrap">
          <li class="warn-color" v-for="item in colors" :key="item.color">
            <span class="warn-flag" :style="{ background: item.color }"></span>
            <label class="warn-text">{{ item.label }}</label>
          </li>
        </ul>
      </div>
      <!-- 表格数据 -->
      <el-table :data="tableData" ref="table" border v-load="loading" :loading-text="$t('989')">
        <!-- 姓名 -->
        <el-table-column prop="staff_name" fixed="left" align="center" :label="$t('22')" width="180">
          <template slot-scope="{ row }">
            {{ row.staff_name }}
            <span v-if="row.staff_code">({{ row.staff_code }})</span>
          </template>
        </el-table-column>
        <!-- 动态列循环 -->
        <el-table-column
          v-for="item in tableCheckColumn"
          class="cloumn"
          :key="item.field_key"
          :label="item.field_name"
          width="140"
          align="center"
        >
          <!-- 不嵌套 -->
          <!-- v-if -->
          <template slot="header" v-if="!(item.children && item.children.length)">
            <el-tooltip v-if="item.remark" class="item" effect="dark" :content="item.remark" placement="top-start">
              <i class="el-icon-warning icon-button"></i>
            </el-tooltip>
            <span>{{ item.field_name }}</span>
          </template>
          <template slot-scope="{ row }" v-if="!(item.children && item.children.length)">
            <!-- {{ row }} -->
            <!--
              是否可点击查看详情
              detail_type 为获取时的参数
            -->
            <el-link type="primary" v-if="item.have_detail" @click="handleShowDetail(item, row)">{{
              row[item.field_key]
            }}</el-link>
            <div v-else class="table-box-attendance">{{ row[item.field_key] }}</div>
          </template>
          <!-- 表格是否嵌套 -->
          <!-- 嵌套 -->
          <template v-if="item.children && item.children.length">
            <el-table-column
              v-for="(el, index) in item.children"
              class="cloumn"
              :key="el.field_name"
              :prop="el.field_key"
              :label="el.field_name"
              align="center"
              width="140"
            >
              <template slot="header">
                <el-tooltip v-if="el.remark" class="item" effect="dark" :content="el.remark" placement="top-start">
                  <i class="el-icon-warning icon-button"></i>
                </el-tooltip>
                <span>{{ el.field_name }}</span>
              </template>
              <template slot-scope="scope">
                <!-- 是否可点击查看详情 detail_type 为获取时的参数 -->
                <el-link type="primary" v-if="item.have_detail" @click="handleShowDetail(el, scope.row)">{{
                  scope.row[el.field_key] ? scope.row[el.field_key][index] : ''
                }}</el-link>
                <div v-else class="table-box-attendance">{{ scope.row[el.field_key] }}</div>
              </template>
            </el-table-column>
          </template>
        </el-table-column>
        <!-- 日期循环 -->
        <el-table-column v-for="item in tableDays" class="cloumn" :key="item" :prop="item" :label="item">
          <template slot-scope="scope">
            <div class="table-box-attendance" :style="{ color: scope.row[item].color }">{{ scope.row[item].msg }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="[20, 60, 80, 100]"
        :page-size="form.page_size"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="form.count"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <template>
      <TableDetail ref="tableDetail" />
    </template>
  </div>
</template>

<script>
import department from '_c/department'
import job from '_c/jobSelect'
import JobStatus from '_c/job-status'
import LinearSuperior from '_c/linear-superior'
import {
  attendanceMonth,
  attendanceMonthExcel,
  attendanceMonthField,
  attendanceMonthColor,
  attendanceMonthUpdate
} from 'api/Attendance/monthly-statistics'
import TableDetail from './table-detail'
export default {
  props: {
    cData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    // 部门
    department,
    // 职位
    job,
    // 在职状态
    JobStatus,
    // 直线上级
    LinearSuperior,
    // 表格点击详情
    TableDetail
  },
  data() {
    return {
      title: '', // 标题
      colors: [], // 颜色列表
      dynamicColumns: {
        basic: [], // 基础信息
        attendance: [] // 考勤统计
      },
      ckeckedColumns: [], // 缓冲区已选中
      ckeckedColumnsAttdance: [], // 考勤统计缓冲区已选中
      tableCheckColumn: [], // 表格区动态项 更新报表从缓冲区更新到表格列
      checkAll: true, // 是否全选
      checkAllAttdance: true, // 考勤统计全选
      isIndeterminate: false, // 基础信息 是否半选 优先于全选
      isIndeterminateAttdance: false, // 考勤统计 规则同上
      loading: false, // 表格loading
      tableData: [], // 表格数据
      tableDays: [], // 表格天数列
      form: {
        count: 0,
        date: ['2021-11-16', '2021-12-15'],
        month_cycle_id: 0, // 月度汇总周期ID,从考勤周期列表中获取，本月时为0时就传0
        search_name: '', // 员工
        page: 1,
        page_size: 20,
        start_date: '2021-11-16', // 开始日期
        end_date: '2021-12-15', // 结束日期
        department_id: '', // 部门ID
        manager_id: '', // 直线上级ID
        field_key: [], // 导出表头，使用attendanceMonthField接口中的field_key字段
        states: ['1', '3'] // 默认选中 在职 待离职
      },
      isShowUpdateTips: false
    }
  },
  created() {
    // 数据初始化 参数说明见this.form
    const { begin, end, month_cycle_id, month } = this.cData
    this.form.date = [begin, end]
    this.form.start_date = begin
    this.form.end_date = end
    this.form.month_cycle_id = month_cycle_id
    this.title = month
    // 搜索
    this.handlerSearch()
    // 初始化赋值
    // 获取动态列
    attendanceMonthField().then(res => {
      this.dynamicColumns = res.data
      // 基础信息 考勤统计
      const { basic, attendance } = this.dynamicColumns
      // 默认全选 取消半选
      this.ckeckedColumns = basic // [...basic, ...attendance]
      this.ckeckedColumnsAttdance = attendance
      this.tableCheckColumn = basic.concat(attendance)
      this.checkAll = true
      this.isIndeterminate = false
    })
    // 获取所有颜色
    attendanceMonthColor().then(res => {
      this.colors = res.data
    })
  },
  methods: {
    doShowUpdateTips() {
      if (this.isShowUpdateTips) return
      this.isShowUpdateTips = true
    },
    // 获取详情参数
    // @parma { Object } detailColumnKeys 循环的数据查询的key对象
    // @parma { Object } row 当前行
    handleShowDetail(detailColumnKeys, row) {
      // 获取详情时候的参数
      const { detail_type, detail_type_id } = detailColumnKeys
      const { start_date, end_date, month_cycle_id } = this.form
      // 参数说明见当前目录下 table-detail.vue
      this.$refs.tableDetail.init({
        start_date,
        end_date,
        type: detail_type,
        staff_id: row.staff_id,
        type_id: detail_type_id,
        month_cycle_id
      })
      // console.log(detail_type)
    },
    // 动态列选项状态变化
    handleCheckedCitiesChange(checkedColumns, type) {
      this.doShowUpdateTips()
      const length = this.dynamicColumns[type].length
      // 全选则length等于基本信息和考勤统计之和
      this[type === 'basic' ? 'checkAll' : 'checkAllAttdance'] = checkedColumns.length === length
      // 半选则已选大于0且小于他俩之和length
      this[type === 'basic' ? 'isIndeterminate' : 'isIndeterminateAttdance'] =
        checkedColumns.length > 0 && checkedColumns.length < length
    },
    // 动态列全选
    handleCheckAllChange(isCheckAll, type) {
      this.doShowUpdateTips()
      // 是否全选
      this[type === 'basic' ? 'ckeckedColumns' : 'ckeckedColumnsAttdance'] = isCheckAll ? this.dynamicColumns[type] : []
      // 取消半选
      this[type === 'basic' ? 'isIndeterminate' : 'isIndeterminateAttdance'] = false
    },
    // 更新列表
    handleUpdateColums() {
      this.tableCheckColumn = [...this.ckeckedColumns, ...this.ckeckedColumnsAttdance]
      this.handlerSearch('update')
    },
    //  分页相关
    handleSizeChange(val) {
      this.form.page_size = val
      this.handlerSearch()
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.handlerSearch()
    },
    // 部门选择
    handlerChangeDep(_, b) {
      this.form.department_id = b.slice(-1)[0]
    },
    // 搜索 表格数据
    handlerSearch(type) {
      this.loading = true
      // 存在type时则更新后台数据
      const requestMethods = type === 'update' ? attendanceMonthUpdate : attendanceMonth
      requestMethods(this.form)
        .then(res => {
          // console.log(res)
          const {
            datalist,
            days: { m_d },
            count
          } = res.data
          // 表格数据
          this.tableData = datalist
          // 表格天数
          this.tableDays = m_d
          // 表格数据总数
          this.form.count = count
          // 更新时提示
          type === 'update' && this.$message.success(this.$t('1971'))
        })
        .finally(() => (this.loading = false))
    },
    get_field_key() {
      const keys = [
        ...(this.ckeckedColumns?.map(item => item.field_key) || []),
        ...(this.ckeckedColumnsAttdance?.map(item => item.field_key) || [])
      ]
      return keys
    },
    // 导出
    handlerAttendanceExcel() {
      this.form.field_key = this.get_field_key()
      attendanceMonthExcel(this.form).then(res => {
        const { object_url } = res.data
        if (object_url) window.location.href = object_url
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.update-select {
  display: flex;
  align-items: center;
}
.common-header {
  width: calc(100% + 50px);
  transform: translateX(-25px) translateY(-2px);
  padding: 0 25px 0 25px;
  font-size: 16px;
  user-select: none;
  margin-bottom: 22px;
  &::before {
    display: none;
  }
}
.dynamic-column {
  display: flex;
  // flex-wrap: wrap;
  font-size: 14px;
  .select-all-attendance {
    width: 100px;
    align-self: flex-start;
    text-align: right;
  }
  &-title {
    width: 150px;
  }
  &-active {
    flex: 1;
  }
}
// 色值
.warn-wrap {
  display: flex;
  justify-content: right;
  margin-bottom: 10px;
  .warn-color {
    display: inline-block;
    .warn-flag {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      margin: 0 5px 0 20px;
    }
  }
}
</style>
